import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor, useNavigate, useLocation } from 'react-router-dom';
import logo from '../../images/logo.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';
import ProfileTienda from '../ProfileTienda/ProfileTienda';
import LinksNav from '../LinksNav/LinksNav';
import AuthUsuario from '../AuthUsuario/AuthUsuario'
export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    const showLogo = location.pathname === '/' || location.pathname.startsWith('/categoria-tiendas') || location.pathname.startsWith('/tiendas');
    return (
        <header>
            <nav className={!showLogo ? 'navInternal' : ''}>
                {showLogo ? (
                    <Anchor to={`/`} className='logo' aria-label="Ir a Inicio">
                        <img src={logo} alt="Club Vende Más" width="48" height="48" />
                    </Anchor>
                ) : (
                    <button className="back" onClick={goBack} aria-label="Volver a la página anterior"> <FontAwesomeIcon icon={faArrowLeft} /> </button>
                )}

                <div className='deFLexNavs'>
                    <LinksNav />
                    <AuthUsuario />
                    <Favoritos />
                    <InputSerach />
                    <div className={`nav_toggle ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)} role="button" aria-label="Abrir menú lateral de usuario" tabIndex={0}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {showLogo ? (
                            <Profile onClose={() => setIsOpen(false)} />
                        ) : (
                            <ProfileTienda onClose={() => setIsOpen(false)} />
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}
